package com.tovtalk.ui.adaptive

import androidx.compose.runtime.*

enum class WindowSizeClass {
    Compact,        // < 600dp — phone portrait
    MediumCompact,  // 600-840dp — phone landscape / small tablet portrait
    Medium,         // 840-1024dp — tablet portrait / small tablet landscape
    Expanded,       // 1024-1440dp — tablet landscape / small desktop
    Large,          // 1440-1920dp — desktop
    ExtraLarge      // > 1920dp — wide screen / 4K
}

val LocalWindowSizeClass = staticCompositionLocalOf { WindowSizeClass.Compact }

expect @Composable fun rememberScreenWidthDp(): State<Float>

@Composable
fun rememberWindowSizeClass(): WindowSizeClass {
    val widthDp by rememberScreenWidthDp()
    return remember(widthDp) {
        when {
            widthDp < 600f -> WindowSizeClass.Compact
            widthDp < 840f -> WindowSizeClass.MediumCompact
            widthDp < 1024f -> WindowSizeClass.Medium
            widthDp < 1440f -> WindowSizeClass.Expanded
            widthDp < 1920f -> WindowSizeClass.Large
            else -> WindowSizeClass.ExtraLarge
        }
    }
}
